import * as Constants from '../Constants'
import { createAsyncThunk } from '@reduxjs/toolkit';

function createSearchThunk(thunkName, path, pageSize,paramName){


  return createAsyncThunk(thunkName, async ({param, page}) => {


    try {
      var myHeaders = new Headers();
      myHeaders.append("X-Api-Key", "ApiKeyTest");
      myHeaders.append('Access-Control-Allow-Origin', Constants.PATH);
      myHeaders.append('Access-Control-Allow-Credentials', 'true');
    
      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
        dataType:"json"
      };
      let paramObj = {
        pageNumber:page,
        pageSize:pageSize,
        oznakaMesta: Constants.UNIVERSE 
    };
    paramObj[paramName] = param;
      let params = new URLSearchParams(paramObj);
      const res = await fetch(Constants.API_ROOT + path +`?` + params, requestOptions);
      return res?.json();
    } catch (error) {
      return [];
    }
    
  
  });
}


export const fetchFamilies = createSearchThunk("fetchFamilies",`/api/DefaultSearch/GetPorodice`, 20, "surname");
export const fetchPopulation = createSearchThunk("fetchPopulation",`/api/DefaultSearch/GetPopulacija`, 20, "surname");
export const fetchSchools = createSearchThunk("fetchSchools",`/api/DefaultSearch/GetSkole`, 20, "godinaUpisa");
export const fetchStreets = createSearchThunk("fetchStreets",`/api/DefaultSearch/GetKuceUUlici`, 20, "streetname");


export const fetchMembers = createSearchThunk("fetchMembers",`/api/DefaultSearch/GetPopulacijaByDocumentRBR`, 20, "documentRBR");


export const fetchHouseByPopulation = createSearchThunk("fetchHouseByPopulation",`/api/HouseSearch/GetPopulacijaByRbr`, 20, "rbr");
export const fetchHouseByHouse = createSearchThunk("fetchHouseByHouse",`/api/HouseSearch/GetPopulacijaByRbrKuca`, 20, "rbr");
export const fetchHouseBySchool = createSearchThunk("fetchHouseBySchool",`/api/HouseSearch/GetPopulacijaByRbrSkola`, 20, "rbr");


// export function fetchFamily() {
//   return dispatch => {
//   //   dispatch(setLoadingBookState()); // Show a loading spinner
//       fetch(`/api/GetPorodice`, (response) => {
//       //dispatch(doneFetchingBook()); // Hide loading spinner
//       if(response.status == 200){
//         dispatch(setFamily(response.json)); // Use a normal function to set the received state
//       }else { 
//         dispatch(someError)
//       }
//     })
//   }
//  }
 
//  function setFamily(data) {
//   return { type: 'SET_FAMILY', data: data };
//  }